<!-- /src/components/common/Header/HeaderMenu.vue -->
<template>
  <div class="header__menu"
  >
    <div class="header__menu__container">
      <div class="header__menuPad">
        <div class="header__menu__nav-container header__menu__internal-nav">
          <ul class="header__menuItems header__menuItems--primary">
            <li class="header__menuItems__item"
              v-for="(link, index) in internalLinks"
              :key="index"
            >
              <router-link
                class="header__menuItems__itemLink"
                :to="link.href"
                ><span v-html="getTitle(link)"></span></router-link
              >
            </li>
          </ul>
        </div>
        <!--
          External Links — moved from AppsMenu.vue by client request (July 2026).
          Rendered as text-only links to fit the dropdown format.
          AppsMenu.vue is preserved (commented out in Header.vue) with the
          original icon-grid layout — revert there if image-based links are needed.
        -->
        <div class="header__menu__nav-container header__menu__external-nav">
          <ul class="header__menuItems header__menuItems--secondary">
            <li class="header__menuItems__item"
              v-for="(link, index) in externalLinks"
              :key="index"
            >
              <a
                class="header__menuItems__itemLink"
                :href="link.href"
                target="_blank"
                >{{ link.link_title }}</a
              >
            </li>
          </ul>
        </div>
        <div class="header__menu__footer">
          <ul class="header__menuItems header__menuItems--secondary">
            <li class="header__menuItems__item">
              <router-link class="header__menuItems__itemLink" to="/"
                >Dashboard</router-link
              >
            </li>
            <!-- <li class="header__menuItems__item">
              <router-link class="header__menuItems__itemLink" to="/">Profile</router-link>
            </li>-->
            <li class="header__menuItems__item">
              <a
                class="header__menuItems__itemLink"
                href="#"
                @click.prevent="$store.dispatch('user/logout')"
                >Logout</a
              >
            </li>
          </ul>
          <div class="header__menuCopyright">
            &copy; CARR Inc. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // data() {
  //   return {

  //   }
  // },
  computed: {
    primaryMenu() {
      const primaryMenu = this.$store.getters['options/getOptionPosts'](
        'primaryMenu',
      )
      return primaryMenu
    },
    internalLinks() {
      const { internalItems } = this.primaryMenu
      return internalItems
    },
    externalLinks() {
      const { externalItems } = this.primaryMenu
      return externalItems
    },
  },

  methods: {
    getTitle(link) {
      return (link.icon) ? `<img class="menu-item--image" src="${link.icon}">` : link.link_title
    },
  },
}
</script>

<style scoped>

.header {
  &__menu {
    position: absolute;
    top: 100%;
    margin-top: 1rem;
    border-radius: 1rem 0 1rem 1rem;
    right: 0;
    width: 300px;
    /* min-height: calc(100vh - 85px); */
    background-color: rgba(var(--brandAccent-RGB), 0.9);
    z-index: 5;
    text-align: right;
    color: white;
    text-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.3);
    &Pad {
      padding: 1.5rem;
    }
    &Items {
      margin: 0;
      text-transform: uppercase;
      &--primary {
        font-size: 1.4rem;
        line-height: 1;
      }
      &--secondary {
        font-size: 0.75rem;
        font-weight: var(--fontWeightSemibold);
        &:before {
          width: 80px;
          height: 3px;
          margin-left: auto;
          margin-bottom: 0.5rem;
          background-color: white;
          content: '';
          display: block;
        }
      }
      &__item {
        padding: 0.5rem 0;
        &Link {
          color: inherit;
        }
      }

      &:first-child {
        margin-top: 0;
        li:first-child {
          padding-top: 0;
        }
      }
    }

    &__external-nav {
      .header__menuItems--secondary {
        font-size: 1.125rem;
      }
      .header__menuItems__item {
        padding: 0 0 0.5rem 0;
      }
    }

    &__footer {
    }

    &Copyright {
      margin-top: 2rem;
      font-weight: var(--fontWeightExtraBold);
      font-size: 0.5rem;
    }
  }
}

</style>
